var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combine } from 'zustand/middleware';
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState) { return ({
        toggleIsPinnedMenu: function () {
            return setState(function (state) {
                if (state.isPinned) {
                    return __assign(__assign({}, state), { isOpenMenu: false, isPinned: false });
                }
                return __assign(__assign({}, state), { isOpenMenu: true, isPinned: true });
            });
        },
        setIsOpenMenu: function (value) {
            return setState(function (state) { return (__assign(__assign({}, state), { isOpenMenu: value })); });
        },
        toggleOpenMenu: function () {
            return setState(function (state) { return (__assign(__assign({}, state), { isOpenMenu: !state.isOpenMenu })); });
        },
        reset: function () { return setState(function () { return initialValues; }); },
    }); });
};
